/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo multiselect
--------------------------------------------------------------------------------

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;
    var MultiSelect = kendo.ui.MultiSelect;
    if (!MultiSelect || MultiSelect.updated) return;

    var Widget = kendo.ui.Widget,
        AVATAR = "avatar",
        ATTR_TITLE = "title",
        ATTR_VAL_UI_TYPE = "valUi",
        NS = '.kendoMultiSelect',
        DISABLED = 'disabled',
        STATEDISABLED = 'k-state-disabled',
        ARIA_DISABLED = 'aria-disabled',
        READONLY = 'readonly',
        STATEREADONLY = "k-state-readonly",
        ARIA_READONLY = 'aria-readonly',
        CLICK = 'click' + NS,
        KEYDOWN = 'keydown' + NS,
        MOUSEENTER = 'mouseenter' + NS,
        MOUSELEAVE = 'mouseleave' + NS,
        HOVEREVENTS = MOUSEENTER + ' ' + MOUSELEAVE,
        HOVERCLASS = 'k-state-hover',
        LI = 'li',
        proxy = $.proxy;

    /**
     * Overwrite of original editable now also moves styles and needed events to top wrapper (widget wrapper)
     */
    function multiSelectEditable(options) {
        var self = this,
            disable = options.disable,
            readonly = options.readonly,
            wrapper = self.wrapper.off(NS),
            tagList = self.tagList.off(NS),
            input = self.element.add(self.input.off(NS));
        if (!readonly && !disable) {
            wrapper
                .removeClass(STATEDISABLED)
                .removeClass(STATEREADONLY)
                .on(HOVEREVENTS, self._toggleHover)
                .on('mousedown' + NS + ' touchend' + NS, proxy(self._wrapperMousedown, self));
            self.input
                .on(KEYDOWN, proxy(self._keydown, self))
                .on('paste' + NS, proxy(self._search, self))
                .on('focus' + NS, proxy(self._inputFocus, self))
                .on('focusout' + NS, proxy(self._inputFocusout, self));
            self._clear.on('click' + NS, proxy(self._clearClick, self));
            input.prop(DISABLED, false).prop(READONLY, false).attr(ARIA_DISABLED, false).attr(ARIA_READONLY, false);
            tagList.on(MOUSEENTER, LI, function () {
                $(this).addClass(HOVERCLASS);
            }).on(MOUSELEAVE, LI, function () {
                $(this).removeClass(HOVERCLASS);
            }).on(CLICK, 'li.k-button .k-select', proxy(self._tagListClick, self));
        } else {
            if (disable) {
                wrapper.addClass(STATEDISABLED).removeClass(STATEREADONLY);
            } else {
                wrapper.addClass(STATEREADONLY).removeClass(STATEDISABLED);
            }
            input.prop(DISABLED, disable).prop(READONLY, readonly).attr(ARIA_DISABLED, disable).attr(ARIA_READONLY, readonly);
        }
    }

    /**
     * The original widget "class" gets updated in two steps. First is constructor
     * update. newInit function becomes the new constructor of the component.
     * In the constructor the widget is also republished as kendo plugin, so that
     * jQuery.fn gets updated. Second step is overriding of specific widget methods
     * when needed.
     */
    var oldMultiSelectInit = MultiSelect.fn.init,
        newMultiSelectInit = function (element, options) {
            var self = this,
                $element = $(element);
            // update options from specifically prefixed data on element
            options = kendo.elementOptions($element, "multiselect", options);
            if (options.enabled === undefined)
                options.enabled = !$element.is("[disabled]");
            if (options.readonly === undefined)
                options.readonly = $element.is("[readonly]");
            // remove avatar class before the wrapper gets created
            $element.removeClass(AVATAR);
            // call original constructor
            oldMultiSelectInit.call(self, element, options);
            // remember title text - needed for various description UI types
            // execute with caution to not remove the title by mistake
            self.options.titleText = self.options.titleText || self.element.attr(ATTR_TITLE);
            self.element.removeAttr(ATTR_TITLE);
            // update validation UI type in options to be sure
            self.options.validationUi = self.options.validationUi || self.element.data(ATTR_VAL_UI_TYPE);
            // update title / tooltip popups
            Widget.fn.descriptionUi.call(self);
            // remove input class from wrapper for easier styling
            self.wrapper.removeClass("k-input");
        };

    MultiSelect = MultiSelect.extend({
        // new init
        init: newMultiSelectInit,
        // default options extension
        options: kendo.getUpdatedWidgetOptions(),

        fixorder: function () {
            var optionsMap = {};
            var $selectElement = $(this.element);
            var options = $selectElement.find('option').remove();
            $.each(this.value(), function (widgetIndex, widgetValue) {
                $.each(options, function (selectIndex, selectOption) {
                    if (selectOption.getAttribute('value') == widgetValue) {
                        $selectElement.append(selectOption);
                        optionsMap[widgetValue] = widgetIndex;
                    }
                });
            });
            this._optionsMap = optionsMap;
            this._customOptions = optionsMap;
        },
        _editable: multiSelectEditable
    });

    MultiSelect.updated = true;

    kendo.ui.plugin(MultiSelect);

})(window.kendo.jQuery);
